<template>
  <Card class="suggest-card" style="width:90%;margin-left: 5%;margin-top: 10px">
    <div slot="title">
      <div class="title-div">{{ comment.name }}</div>
      <div class="sub-title-div">
        {{ format(comment.createtime) }}
      </div>
      <Rate v-if="hasScore" allow-half disabled v-model="comment.score"/>
    </div>
    <Tag slot="extra" color="blue" style="font-size: 20px" v-if="hasBtn" @click.native="showReply">{{ btnTxt }}</Tag>
    <template v-if="replyFlag">
      <Input prefix="ios-contact" v-if="!hasName" v-model="retData.name" placeholder="Enter name"
             style="width: 45%;margin-left: 5%;margin-top: 10px"/>
      <Input prefix="ios-mail" v-if="!hasName" v-model="retData.email" placeholder="Enter email"
             style="width: 40%;margin-left: 5%;margin-top: 10px"/>
      <comment-edit style="width: 90%;margin-left: 5%;margin-top: 10px" :default-html="retData.suggestion"
                    @changeHtml="changeHtml"></comment-edit>
      <Button type="success" @click="submitData"
              style="width: 90%;margin-left: 5%;margin-top: 10px;margin-bottom: 20px">Send Your Message
      </Button>
    </template>
    <div class="suggest-div" style="width: 100%" v-html="comment.suggestion">
    </div>
    <slot name="replay">
    </slot>
  </Card>
</template>

<script>
import {formatDate} from "@/components/util/date";
import util from "@/components/util/util";
import CommentEdit from "../public/commentEdit.vue";

export default {
  name: "SuggestItem",
  components: {CommentEdit},
  props: {
    comment: Object,
    btnTxt: String,
    parentId: String,
  },
  data: function () {
    return {
      replyFlag: false,
      retData: {
        curstatu: this.parentId,
        name: "",
        email: "",
        suggestion: "",
        replyId: ""
      }
    }
  },
  mounted() {
    this.retData.name = this.$cookies.get("easyflyName");
    this.retData.email = this.$cookies.get("easyflyEmail");
    this.changeImgSize();
  },
  methods: {
    changeImgSize() {
      setTimeout(() => {
        ["img", "image", "video"].map(item => {
          let parentList = this.$(".suggest-div");
          if (parentList.length > 0) {
            for (var k = 0; k < parentList.length; k++) {
              let parent = parentList.eq(k);
              let targetList = parent.find(item);
              if (targetList.length > 0) {
                for (var i = 0; i < targetList.length; i++) {
                  var target = targetList.eq(i);
                  console.log(parent.width(), target.width());
                  if (parent.width() < target.width()) {
                    target.css("max-width", "100%")
                  }
                }
              }
            }
          }
        });

      }, 200)
    },
    changeHtml(html) {
      this.retData.suggestion = html;
    },
    submitData: function () {
      if (util.isNull(this.retData.name)) {
        this.$Message.error("please enter name!");
        return;
      }
      if (util.isNull(this.retData.email)) {
        this.$Message.error("please enter email!");
        return;
      }
      if (util.isNull(this.retData.suggestion)) {
        this.$Message.error("please enter something!");
        return;
      }
      if (util.isNull(this.retData.suggestion.replaceAll("<p><br></p>", ""))) {
        this.$Message.error("please enter something!");
        return;
      }
      var reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
      if (!reg.test(this.retData.email)) {
        this.$Message.error("email is not allow");
        return;
      }
      this.retData.replyId = this.comment.id;
      this.$emit("submitData", this.retData);
      this.replyFlag = false;
      this.retData.suggestion = "";
    },
    showReply: function () {
      this.replyFlag = !this.replyFlag;
    },
    format: function (date) {
      return formatDate(new Date(date), "yyyy-MM-dd hh:mm:ss")
    }
  },
  computed: {
    hasBtn: function () {
      if (util.isNull(this.btnTxt)) {
        return false;
      }
      return true;
    },
    hasScore: function () {
      if (util.isNull(this.comment.score)) {
        return false;
      }
      return true;
    },
    hasName: function () {
      if (util.isNull(this.$cookies.get("easyflyName"))) {
        return false;
      }
      return true;
    }
  }
}
</script>

<style scoped>
.title-div {
    display: inline-block;
    margin-right: 20px;
    font-weight: bold;
    font-size: 20px;
}
.sub-title-div{
    display: inline-block;
    margin-right: 20px;
    color: darkgrey;
}
</style>